import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const clientEnv = createEnv({
  skipValidation: process.env.NODE_ENV === "test", // Do not run validations in test environment / Github Actions
  shared: {
    NODE_ENV: z.enum(["development", "production", "test"]).optional(),
  },
  client: {
    NEXT_PUBLIC_APP_URL: z.string().url(),
    NEXT_PUBLIC_DASHBOARD_PORT: z.string().optional(), // optional, we only use a port in local development
    NEXT_PUBLIC_WWW_URL: z.string().url(),
    NEXT_PUBLIC_WWW_PORT: z.string().optional(), // optional, we only use a port in local development
    NEXT_PUBLIC_SERVER_URL: z.string().url(),
    NEXT_PUBLIC_SERVER_PORT: z.string().optional(), // optional, we only use a port in local development
  },
  runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
    NEXT_PUBLIC_DASHBOARD_PORT: process.env.NEXT_PUBLIC_DASHBOARD_PORT,
    NEXT_PUBLIC_WWW_URL: process.env.NEXT_PUBLIC_WWW_URL,
    NEXT_PUBLIC_WWW_PORT: process.env.NEXT_PUBLIC_WWW_PORT,
    NEXT_PUBLIC_SERVER_URL: process.env.NEXT_PUBLIC_SERVER_URL,
    NEXT_PUBLIC_SERVER_PORT: process.env.NEXT_PUBLIC_SERVER_PORT,
  },
});
